import { Card, CardBody } from '@chakra-ui/react'
import React from 'react'
import NextStepContent from './NextStepContent'

interface Props {
  scopeCircleId: string
  meetingId?: string
  threadId?: string
  onCreated(nextStepId: string): void
  onCancel(): void
}

// The three questions unfolded inside a tension, during a meeting. Rendered as
// a Card with the `activity` variant, exactly like the meeting note above it:
// a next step is an element OF the tension, not a panel bolted under it
// (Yohan, 10/08/2026). Same form as the board's modal — one implementation,
// two settings.
export default function NextStepInlineForm({
  scopeCircleId,
  meetingId,
  threadId,
  onCreated,
  onCancel,
}: Props) {
  return (
    // ⚠️ `mx={5}` since 11/08: the comment here used to claim the stream
    // carried the horizontal margin, and it does not — ThreadActivities is a
    // VStack with no padding at all. The meeting note insets itself with
    // `m={5}`, so without this the form ran edge to edge while the note above
    // it did not, and the two stopped reading as blocks of the same tension.
    // A generous top margin detaches it from the last activity — glued to it,
    // the form read as part of what precedes instead of a new one to fill.
    <Card mt={6} mb={4} mx={5} variant="activity">
      <CardBody>
        <NextStepContent
          compact
          scopeCircleId={scopeCircleId}
          meetingId={meetingId}
          threadId={threadId}
          onCreate={onCreated}
          onClose={onCancel}
        />
      </CardBody>
    </Card>
  )
}
